import styled from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

export const Wrapper = styled.div`
  display: flex;
  align-self: stretch;
  flex-direction: column;
  position: relative;
`;

export const Button = styled.button`
  min-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: ${colors.white};
  background-color: ${colors.blueGrey};
  border: 0;
  padding: 0.6rem 1rem;
  height: 60px;

  @media ${device.isDesktop} {
    height: auto;
  }

  svg {
    path {
      fill: ${colors.white};
    }
  }

  :hover,
  :focus {
    background-color: ${colors.blueGrey50};

    color: ${colors.blueGrey};

    div {
      color: ${colors.blueGrey};
    }
    svg {
      path {
        fill: ${colors.blueGrey};
      }
    }
  }
`;

export const LoginLeftWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  padding-left: 18px;
  justify-content: flex-start;
  align-items: center;

  @media ${device.isDesktop} {
    padding: 0;
  }
`;

export const LoginRightWrapper = styled.div`
  flex-basis: 15%;
  display: flex;
  align-self: center;
  justify-content: center;
  pointer-events: none;
  padding-top: 5px;

  @media ${device.isDesktop} {
    display: none !important;
  }
`;

export const Text = styled.div`
  font-family: VIC;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: -0.32px;
  color: ${colors.white};
`;

export const IconWrapper = styled.div`
  svg {
    width: 15px;
    height: 15px;
    box-sizing: content-box;

    &:before,
    &:after {
      box-sizing: content-box;
    }
  }
`;

export const UserIconWrapper = styled(IconWrapper)`
  margin-top: 6px;
`;

export const Content = styled.div`
  background-color: ${colors.white};
  margin-top: 0px;
  margin-bottom: 50px;
`;
